import { useCallback, useRef } from "react";

import type TrackingAdapter from "../../lib/TrackingAdapter";
import type { SubscriptionTier } from "../../types";
import { endCheckoutSpan } from "../../utils/performanceUtils";

export function useCheckoutLoadedTracking({
  tracker,
  trial,
  subscriptionTier,
}: {
  tracker: TrackingAdapter;
  trial: boolean;
  subscriptionTier: SubscriptionTier | null | undefined;
}) {
  const hasTrackedLoaded = useRef(false);
  const hasEstimate = useRef(false);
  const hasCreditCardLoaded = useRef(false);

  const checkAndTrackLoaded = useCallback(() => {
    if (hasTrackedLoaded.current || !hasEstimate.current || !hasCreditCardLoaded.current) {
      return;
    }
    hasTrackedLoaded.current = true;
    endCheckoutSpan();
    tracker.trackCheckoutFlowLoaded({
      paymentPlatform: "chargebee",
      trial,
      subscriptionTier,
    });
  }, [tracker, trial, subscriptionTier]);

  const onFirstEstimate = useCallback(() => {
    hasEstimate.current = true;
    checkAndTrackLoaded();
  }, [checkAndTrackLoaded]);

  const onCreditCardReady = useCallback(() => {
    hasCreditCardLoaded.current = true;
    checkAndTrackLoaded();
  }, [checkAndTrackLoaded]);

  return { onFirstEstimate, onCreditCardReady };
}
